module.exports = __webpack_public_path__ + "img/NS-J-10.92b67efe.svg";